import { makeStyles } from '@material-ui/core/styles'
import { getAreaSizeConfiguration, getRowSizeConfiguration } from './Item.utils'

const useStyles = makeStyles(
	() => ({
		root: {
			position: 'relative',
			height: '100%',
			width: '100%',
			gridArea: ({ index, itemsCount }) => getAreaSizeConfiguration(itemsCount, index),
			gridRow: ({ index, itemsCount }) => getRowSizeConfiguration(itemsCount, index),
			breakInside: 'avoid',
		},
		image: {
			position: 'absolute',
			top: 0,
			right: 0,
			bottom: 0,
			left: 0,
			backgroundSize: 'cover',
			backgroundPosition: 'center',
			backgroundRepeat: 'no-repeat',

			'& picture': {
				display: 'flex',
				justifyContent: 'center',
			},
			'& img': {
				objectPosition: 'center',
				objectFit: 'cover',
			},
		},
	}),
	{ name: 'Banners-Banner15-item' },
)

export default useStyles
